var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "FormSingleChoice" } }, [
    _c(
      "div",
      { class: "form-single-choice single-choice-align-" + _vm.align },
      [
        _c("input", {
          staticClass: "form-single-choice-title",
          attrs: { type: "text" },
          domProps: { value: "" + _vm.fieldLabel },
        }),
        _vm._v(" "),
        _c(
          "div",
          [
            _vm._l(_vm.optionsRadio, function (option, index) {
              return _c(
                "div",
                { key: index, staticClass: "form-single-choice-option" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedOptionRadio,
                        expression: "selectedOptionRadio",
                      },
                    ],
                    attrs: {
                      type: "radio",
                      id: "option-" + index,
                      name: "singleChoice",
                    },
                    domProps: {
                      value: option,
                      checked: _vm._q(_vm.selectedOptionRadio, option),
                    },
                    on: {
                      change: function ($event) {
                        _vm.selectedOptionRadio = option
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "option-" + index } }, [
                    _vm._v(_vm._s(option)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "remove-option",
                      on: {
                        click: function ($event) {
                          return _vm.removeOption(index)
                        },
                      },
                    },
                    [_vm._v("X")]
                  ),
                ]
              )
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newOption,
                  expression: "newOption",
                },
              ],
              staticClass: "form-single-choice-new-option",
              attrs: { type: "text", placeholder: "Bir seçenek yazın" },
              domProps: { value: _vm.newOption },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.newOption = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "form-single-choice-add-button",
                on: { click: _vm.addOptionRadio },
              },
              [_vm._v("Seçenek Ekle")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "form-single-choice-add-other-button",
                on: { click: _vm.addOtherOption },
              },
              [_vm._v('"Diğer" seçeneği\n                ekle\n            ')]
            ),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }